import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import RightSideBar from '../RightSideBar/RightSideBar';
import * as logger from '../../../logger';
import {
    CardContent,
    CardHeader,
    Card,
    Grid,
    ListItem,
    List,
    InputAdornment,
    MenuItem,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    makeStyles
} from '@material-ui/core';
import { numberFormat, numberWithCommas, replaceCommas, findArrayObjectIndex } from "../../../utils/utils";
import { addPaymentSideBarCss } from "./PartyCssComponent";
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import AmountInput from '../Inputs/AmountInput';
import TextInputState from '../Inputs/TextInputState';
import {
    PAYMENT_METHODS_LIST
} from "../../../store/constants";
import DateFnsUtils from '@date-io/date-fns';
import { getTripSuggestionSupplier } from "../../../store/actions/userActionCreators";
import { addVendorPayment } from "../../../store/actions/tripActionCreator";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useHistory, useLocation } from 'react-router-dom';
import { Functions } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

import {
    getSuggestionsTrips,
    addSinglePartyPayment,
    getSuggestionsTripsForEdit,
    updateSinglePartyPayment
} from "../../../store/actions/partiesActionCreator";
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
    getAllDrivers,
} from "../../../store/actions/vehicleActionCreator";
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { trackDwebEvent } from '../../analytics';

const filter = createFilterOptions({
    limit: 10
});
const AddPaymentSingleParty = ({ open, onClose, onConfirm, vehicle, partyName, user, dispatchGetSuggestionsTrips, dispatchAddPartyPayment, dispatchGetAllDrivers }) => {

    let submit, tripSubmit, tripEditSubmit;

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    // let partyIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    let partyIdValue = (location.state && location.state.partyId) ? location.state.partyId : (path && path[path.length - 1]) ? path[path.length - 1] : "";

    const [dialogOpen, setDialogOpen] = useState(open);
    const [sideBarTitle, setSideBarTitle] = useState("Add Party Payment");
    const [buttonText, setButtonText] = useState("Choose Opening Balance/Trips");

    const [amountValue, setAmountValue] = useState("");
    const [paymentMethodValue, setPaymentMethodValue] = useState("");
    const [refNumberValue, setRefNumberValue] = useState("");
    const [paymentDateValue, setPaymentDateValue] = useState("");
    const [notesValue, setNotesValue] = useState("");

    const [checkedTrips, setCheckedTrips] = useState([]);
    const [trips, setTrips] = React.useState([]);
    const [tripAmountEditOpen, setTripAmountEditOpen] = React.useState(false);
    const [selectedForEdit, setSelectedForEdit] = React.useState(null);
    const [selectedAmount, setSelectedAmount] = React.useState(0);
    const [tripKey, setTripKey] = React.useState(null);
    const [fullyAllocted, setFullyAllocted] = useState(false);
    const [allocatedText, setAllocatedText] = useState("");
    const [dialogConfirmDisabled, setDialogConfirmDisabled] = useState(false);
    const [designCheck, setDesignCheck] = useState(false);
    const [tripsError, setTripsError] = useState(false);

    // New State Variables .
    const [driverListOpen, setDriverListOpen] = React.useState(false);
    const [isReceivedByDriverFlag, setIsReceivedByDriverFlag] = React.useState(false);
    const [driverValue, setDriverValue] = React.useState({});
    const [remainingAmount, setRemainingAmount] = useState(0);


    const classes = addPaymentSideBarCss();
    // const checkClasses = styles();

    useEffect(() => {
        trackDwebEvent('Dweb Party Payment Initiated', {
            party_id: partyIdValue,
            party_name: user && user.partyName ? user.partyName : "",
            party_contact_number: user && user.partyMobile ? user.partyMobile : "",
            party_balance: user && user.partyBalance ? user.partyBalance : ""
        });
    }, [open]);

    useEffect(() => {
        if (driverListOpen) {
            dispatchGetAllDrivers(
                (data) => {
                    logger.log('Add Party Payment Dweb', 'Get all Drivers Successfull');
                },
                () => {
                    logger.log('Add Party Payment Dweb', 'Get all Drivers Failed');
                }
            );
        }
    }, [driverListOpen]);

    useEffect(() => {

        setTimeout(() => {
            if (checkedTrips && checkedTrips.length > 0) {

                for (var i = 0; i < checkedTrips.length; i++) {

                    if (trips.includes(checkedTrips[i].tripId)) {

                        if (Number(checkedTrips[i].attributionAmount) == Number(checkedTrips[i].tripBalance)) {

                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #0033cc';
                            }

                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #0033cc !important'
                            }

                        } else
                            if (Number(checkedTrips[i].attributionAmount) < Number(checkedTrips[i].tripBalance)) {
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #e8843c';
                                }
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #e8843c !important'
                                }
                            }
                    } else {
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].style = 'border: none !important';
                        }
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0].removeAttribute("style");
                        }
                    }
                }

            }
        }, 90)


    }, [checkedTrips, trips, designCheck])

    const initialValues = {
        amount: amountValue ? numberWithCommas(amountValue) : "",
        paymentMethod: paymentMethodValue ? paymentMethodValue : "Cash",
        refNumber: refNumberValue ? refNumberValue : "",
        paymentDate: paymentDateValue ? paymentDateValue : new Date(),
        notes: notesValue ? notesValue : "",
        isReceivedByDriver: isReceivedByDriverFlag,
        driver: driverValue
    }

    const initialTripValues = {
        trips: trips,
    }

    let initialTripAmountValues = {
        amount: selectedAmount ? selectedAmount : ""
    }

    const handleCancel = () => {
        setDialogOpen(false);
        onClose();
        if (sideBarTitle == "Add Party Payment") {
            trackDwebEvent('Dweb Party Payment Form Cancelled', {
                party_id: partyIdValue,
                party_name: user && user.partyName ? user.partyName : "",
                party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                party_balance: user && user.partyBalance ? user.partyBalance : "",
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date(),
                received_by_driver: isReceivedByDriverFlag
            });
        } else if (sideBarTitle == "Choose Opening Balance/Trips") {
            trackDwebEvent('Dweb Party Payment Form Cancelled', {
                party_id: partyIdValue,
                party_name: user && user.partyName ? user.partyName : "",
                party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                party_balance: user && user.partyBalance ? user.partyBalance : "",
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date(),
                received_by_driver: isReceivedByDriverFlag
            });
        }
    }

    const handleBackClick = () => {
        setSideBarTitle("Add Party Payment");
        setButtonText("Choose Opening Balance/Trips");
    }

    const getFormFields = (values) => {
        let paymentMode = values.paymentMethod;
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.formTitle}>Payment Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setAmountValue(e.target.value);
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3} >
                        <div className={classes.formTitle}>Payment Method</div>
                        <Select
                            name="paymentMethod"
                            variant="outlined"
                            placeholder={'Select Payment Method'}
                            onChange={(e) => { setPaymentMethodValue(e.target.value) }}
                            formControlProps={{ margin: 'none', size: "small" }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV2 }}
                        >
                            {PAYMENT_METHODS_LIST && PAYMENT_METHODS_LIST.map((type) => {
                                return (<MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>);
                            })}
                        </Select>
                    </div>
                ),
            },
            {
                size: 12,
                visible: ['Cheque', 'UPI', 'Bank Transfer'].includes(paymentMode),
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>{(paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}</div>
                        <TextInputState
                            placeholder={"Enter the " + (paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
                            name="refNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setRefNumberValue(e.target.value) }}
                            margin="normal"
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Payment Date</div>
                        <DatePicker
                            disableFuture
                            name="paymentDate"
                            margin="normal"
                            variant="inline"
                            inputVariant="outlined"
                            size="small"
                            onChange={(date) => { setPaymentDateValue(date) }}
                            format="dd-MM-yyyy"
                            placeholder="Enter a Date"
                            required={true}
                            dateFunsUtils={DateFnsUtils}
                            className={classes.mtV2}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Notes</div>
                        <TextInputState
                            placeholder="Enter Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            onChange={(e) => { setNotesValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <Switches
                            size='small'
                            margin='normal'
                            fullWidth={true}
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            className={classes.switch}
                            onChange={(e, value) => {
                                setIsReceivedByDriverFlag(value)
                            }}
                            formGroupProps={{}}
                            formControlLabelProps={{
                                classes: {
                                    root: classes.switchLabel
                                },
                                labelPlacement: 'start',
                            }}
                            name="isReceivedByDriver"
                            data={{ label: 'Received By Driver', value: true }} label="" />
                    </div>
                )
            },
            {
                size: 12,
                visible: values.isReceivedByDriver ? true : false,
                field: (
                    <Autocomplete
                        classes={{
                            listbox: classes.listBoxAutoCompelete,
                            option: classes.listBoxOption,
                            inputRoot: classes.autoCompleteField
                        }
                        }
                        id="select-driver-payment-list"
                        name="driver"
                        size="small"
                        //defaultValue={driverDefaultValue?driverDefaultValue:null}
                        // value={driverValue}
                        onOpen={() => {
                            setDriverListOpen(true)
                        }}
                        onClose={() => {
                            setDriverListOpen(false)
                        }}
                        getOptionSelected={(option, value) => option.id === value.id}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                                // timeout to avoid instant validation of the dialog's form.

                            } else if (newValue && newValue.inputValue) {

                            } else if (newValue && newValue.inputValue === '') {

                            } else {
                                setDriverValue(newValue && newValue.id ? newValue : null);
                            }

                        }}
                        required={false}
                        autoHighlight
                        options={vehicle && vehicle.drivers ? vehicle.drivers : []}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        getOptionValue={option => option.id}
                        getOptionLabel={(option) => {
                            // e.g value selected with enter, right from the input
                            if (typeof option === 'string') {
                                return '';
                            }
                            if (option.inputValue || !option.id) {
                                return '';
                            }
                            return option && option.name ? option.name : ''
                        }}
                        disableCloseOnSelect={false}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            return filtered;
                        }}
                        filterSelectedOptions
                        renderOption={(option, { selected, inputValue }) => {
                            let matchesName, matchesNumber;
                            let partsName, partsNumber;
                            matchesName = match(option.name, inputValue);
                            partsName = parse(option.name, matchesName);
                            matchesNumber = match(option.contactNumber, inputValue);
                            partsNumber = parse(option.contactNumber, matchesNumber);

                            if (option && option.id) {
                                return (
                                    <div className={classes.partyListItem}>
                                        {partsName.map((part, index) => {
                                            return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                                {part.text}
                                            </span>
                                            )
                                        })}
                                        {option.contactNumber && <>
                                            <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                            {partsNumber.map((part, index) => {
                                                return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                                    {part.text}
                                                </span>
                                                )
                                            })}
                                        </>}
                                    </div>
                                );

                            } else {
                                return (
                                    <div className={classes.partyAddListItem}>
                                        <AddPersonIcon className={classes.addPersonIcon} />
                                        <span>{option.name}</span>
                                        <ChevronRightIcon className={classes.cherveRightIcon} />
                                    </div>
                                );
                            }

                        }}
                        textFieldProps={
                            {
                                placeholder: "Select a Driver",
                                variant: "outlined",
                                margin: 'none',
                                name: "driver"
                            }
                        }
                        multiple={false}
                    />
                ),
            },
        ]
    }

    const onSubmit = async values => {

        if (sideBarTitle == "Add Party Payment") {

            const suggestionData = {
                customerId: partyIdValue ? partyIdValue : "",
                paymentAmount: values.amount ? replaceCommas(values.amount) : "",
                isReceivedByDriver: isReceivedByDriverFlag,
            }

            if (isReceivedByDriverFlag && driverValue && driverValue.id) {
                suggestionData['driverId'] = driverValue.id;
            }

            setPaymentMethodValue(values.paymentMethod);
            setPaymentDateValue(values.paymentDate);

            dispatchGetSuggestionsTrips(suggestionData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Add Payment Single Party Dweb", "Get Suppliet trip suggestions successfull");
                        setSideBarTitle("Choose Opening Balance/Trips");
                        setButtonText("Confirm");
                        trackDwebEvent('Dweb Party Payment Choose Opening Balance/Trips', {
                            party_id: partyIdValue,
                            party_name: user && user.partyName ? user.partyName : "",
                            party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                            party_balance: user && user.partyBalance ? user.partyBalance : "",
                            payment_amount: amountValue ? amountValue : "",
                            payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                            payment_date: paymentDateValue ? paymentDateValue : new Date(),
                            received_by_driver: isReceivedByDriverFlag,
                        })
                        if (data.response) {
                            let defaultTrips = [];
                            data.response.forEach(trip => {
                                if (trip && trip.attributionAmount && Number(trip.attributionAmount) != 0) {
                                    defaultTrips.push(trip.tripId)
                                }
                            });
                            setTrips(defaultTrips);
                            setCheckedTrips(data.response);
                            setDesignCheck(!designCheck);
                        }
                    }
                },
                (data) => {
                    logger.log("Add Payment Single Party Dweb", "Get Suppliet trip suggestions failed");
                    trackDwebEvent('Dweb Supplier Payment Form Failed', {
                        party_id: partyIdValue,
                        party_name: user && user.partyName ? user.partyName : "",
                        party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                        party_balance: user && user.partyBalance ? user.partyBalance : "",
                        payment_amount: amountValue ? amountValue : "",
                        payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                        payment_date: paymentDateValue ? paymentDateValue : new Date(),
                        received_by_driver: isReceivedByDriverFlag,
                        failure_reason: data && data.status && data.status.message ? data.status.message : "",
                    });
                }
            );

        }

    }

    const validate = values => {

        const errors = {};

        if (values && !values.amount) {
            errors.amount = "Please enter amount.";
        }

        if (values && values.amount && user && user.partyBalance && Number(replaceCommas(user.partyBalance)) < Number(replaceCommas(values.amount))) {
            errors.amount = "Amount cannot be greater than" + " " + numberFormat(user && user.partyBalance ? user.partyBalance : 0)
        }

        if (values && values.isReceivedByDriver && values.driver && !values.driver.id) {
            errors.driver = "Please select the driver."
        }

        return errors;

    }

    // ************************************************** Trip Forms with Checkboxes For Choose Opening Balance/Trips. **************************************************

    const getTripFormFields = (values) => {

        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV5}>
                            {tripsError &&
                                <div className={classes.errorV1}>Please Choose Trips / Opening Balance</div>
                            }
                            <div className={classes.checkBoxLabel}>Choose Trips / Opening Balance for Payment</div>
                            <Checkboxes
                                name="trips"
                                onChange={(e) => {

                                    let ids = [...trips];
                                    if (ids.includes(e.target.value)) {
                                        ids = ids.filter(function (value, index, arr) {
                                            return value != e.target.value;
                                        });
                                    } else {
                                        ids.push(e.target.value);

                                        let selected = [...checkedTrips];
                                        let index = findArrayObjectIndex('tripId', e.target.value, selected);

                                        const tripBalance = Number(selected[index].tripBalance);

                                        if (remainingAmount <= tripBalance) {
                                            selected[index].attributionAmount = remainingAmount;
                                        } else if (remainingAmount > tripBalance) {
                                            selected[index].attributionAmount = tripBalance;
                                        }
                                        setCheckedTrips(selected);

                                    }
                                    setTrips(ids)
                                    setDesignCheck(!designCheck);
                                }}
                                formControlProps={{
                                    margin: 'none',
                                    className: classes.checkboxInput
                                }}
                                formControlLabelProps={{
                                    className: classes.checkboxTripLabel
                                }}
                                formLabelProps={{
                                    className: classes.checkBoxLabel
                                }}
                                formGroupProps={{
                                    className: 'form-group-checkbox'
                                }}
                                classes={{ checked: classes.checkBoxChecked }}
                                data={getTripsSelection(values)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const getTripsSelection = (values) => {
        let trips = [];
        if (checkedTrips && Array.isArray(checkedTrips)) {
            for (const key in checkedTrips) {
                if (Object.hasOwnProperty.call(checkedTrips, key)) {
                    const tripData = checkedTrips[key];
                    tripData.value = tripData.tripId;
                    tripData.label = (
                        <div className={classes.mlV1} >
                            <Grid container wrap="nowrap" justify="space-between" >
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidthV1 }}>
                                    <Grid item className={classes.gridRoute}>
                                        {tripData.openingBalanceId?<span>{tripData && tripData.displayName ? tripData.displayName : ""}</span>:<><span>{tripData && tripData.startLocation ? tripData.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</span></>}
                                    </Grid>
                                    <Grid item className={classes.gridParam}>
                                        {tripData && tripData.params.length > 0 && tripData.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != tripData.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV1} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidth }}>
                                    {values && values.trips && !values.trips.includes(tripData.tripId) &&
                                        <Grid item className={classes.tripBalance} >
                                            {tripData && tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}
                                        </Grid>
                                    }
                                    {values && values.trips && values.trips.includes(tripData.tripId) &&
                                        <>
                                            <Grid container wrap="nowrap" alignItems="center" classes={{ container: classes.containerWidth }} >
                                                <Grid item className={classes.gridItemV1} >
                                                    <TextField
                                                        name={'attributionAmount-' + tripData.tripId}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth={false}
                                                        value={tripData.attributionAmount ? numberFormat(tripData.attributionAmount) : 0}
                                                        margin="none"
                                                        onClick={(e) => {
                                                            handleTripAmountClick(e, key)
                                                        }}
                                                        className={classes.cardInput}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <div className={Number(tripData.attributionAmount) < Number(tripData.tripBalance) ? classes.divAlignV1 : classes.divAlign} >
                                                        <div className={classes.marginV1} >/</div>
                                                        <div>{tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}</div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item className={classes.gridItemStatus} >
                                                {Number(tripData.attributionAmount) == Number(tripData.tripBalance) &&
                                                    <div className={classes.divBox}>
                                                        Full Payment
                                                    </div>
                                                }
                                                {Number(tripData.attributionAmount) < Number(tripData.tripBalance) &&
                                                    <div className={classes.divBoxPart}>
                                                        Part Payment
                                                    </div>
                                                }
                                            </Grid>
                                        </>
                                    }

                                </Grid>
                            </Grid>
                        </div >
                    )

                    trips.push(tripData);
                }

            }
        }

        return trips;
    }

    const onTripSubmit = values => {

        const paymentDetails = {
            amount: amountValue ? replaceCommas(amountValue) : "",
            paymentMode: paymentMethodValue ? paymentMethodValue : "",
            isAdvance: false,
            paymentData: refNumberValue ? refNumberValue : "",
            customerId: Number(partyIdValue),
            description: notesValue ? notesValue : "",
            paymentDate: paymentDateValue ? Math.round((paymentDateValue.setHours(0, 0, 0, 0) / 1000)) : "",
            receivedByDriver: isReceivedByDriverFlag,
        }

        if (isReceivedByDriverFlag) {
            paymentDetails.driverId = driverValue && driverValue.id ? driverValue.id : null
        }

        if (trips && trips.length > 0) {
            const tripList = []
            trips.map((tripData) => {
                const filteredData = checkedTrips.filter((tripListData) => tripListData.tripId == tripData);
                if (filteredData && filteredData[0] && filteredData[0].attributionAmount != 0) {
                    if(filteredData && filteredData[0] && filteredData[0].tripId && filteredData[0].tripId =='openingBalance'){
                        tripList.push({
                            openingBalanceId: filteredData && filteredData[0] && filteredData[0].openingBalanceId ? filteredData[0].openingBalanceId : "",
                            attributionAmount: filteredData && filteredData[0] && filteredData[0].attributionAmount ? Number(filteredData[0].attributionAmount) : ""
                        })
                    }else{
                        tripList.push({
                            tripId: filteredData && filteredData[0] && filteredData[0].tripId ? Number(filteredData[0].tripId) : "",
                            attributionAmount: filteredData && filteredData[0] && filteredData[0].attributionAmount ? Number(filteredData[0].attributionAmount) : ""
                        })
                    }
                }
            });
            paymentDetails.tripsAttributed = tripList;
        }

        dispatchAddPartyPayment(paymentDetails,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Add Payment Single Party Dweb', 'Add vendor payment Sucsessfull');
                    trackDwebEvent('Dweb Party Payment Successful', {
                        party_id: partyIdValue,
                        party_name: user && user.partyName ? user.partyName : "",
                        party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                        party_balance: user && user.partyBalance ? user.partyBalance : "",
                        payment_amount: amountValue ? amountValue : "",
                        payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                        payment_date: paymentDateValue ? paymentDateValue : new Date(),
                        received_by_driver: isReceivedByDriverFlag,
                        count_of_trips: trips && trips.length ? trips.length : ""
                    });
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            (data) => {
                logger.log('Add Payment Single Party Dweb', 'Add vendor payment Failed');
                trackDwebEvent('Dweb Payment Payment Choose Opening Balance/Trips Failed', {
                    party_id: partyIdValue,
                    party_name: user && user.partyName ? user.partyName : "",
                    party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                    party_balance: user && user.partyBalance ? user.partyBalance : "",
                    payment_amount: amountValue ? amountValue : "",
                    payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                    payment_date: paymentDateValue ? paymentDateValue : new Date(),
                    received_by_driver: isReceivedByDriverFlag,
                    count_of_trips: trips && trips.length ? trips.length : "",
                    failure_reason: data && data.status && data.status.message ? data.status.message : ""
                })
            }
        )

    }

    const tripValidate = values => {

        let errors = [];

        if (values && values.trips && values.trips.length == 0) {
            setTripsError(true);
        } else {
            setTripsError(false);
        }

        let allocatedAmount = 0;
        let amountValueEntered = Number(replaceCommas(amountValue));

        for (var i = 0; i < values.trips.length; i++) {

            let filteredTrip = checkedTrips.filter((tripData) => tripData.tripId == (values && values.trips[i] ? values.trips[i] : ""))
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (allocatedAmount == amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered));
            setRemainingAmount(0);
            setFullyAllocted(true);
        } else if (allocatedAmount < amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered - allocatedAmount));
            setFullyAllocted(false);
            setRemainingAmount(replaceCommas(amountValueEntered - allocatedAmount));
        }

        return errors;
    }


    // ******************************************** Edit Amount Dialog Actions and Functions. ********************************************
    const handleTripAmountClick = (e, key) => {
        if (checkedTrips) {
            setTripKey(key);
            setSelectedForEdit(checkedTrips[key]);
            setSelectedAmount(checkedTrips && checkedTrips[key] && checkedTrips[key].attributionAmount ? checkedTrips[key].attributionAmount : 0)
            setTripAmountEditOpen(true);
        }
    }

    const handleEditAmountClose = () => {
        setTripKey(null);
        setSelectedForEdit(null);
        setSelectedAmount(null);
        setTripAmountEditOpen(false);
    }

    const onTripEditSubmit = values => {
        if (Object.keys(editAmountValidate(initialTripAmountValues)).length == 0) {
            let values = [...checkedTrips];
            values[tripKey].attributionAmount = replaceCommas(selectedAmount);
            setCheckedTrips(values);
            setTripKey(null);
            setSelectedForEdit(null);
            setSelectedAmount(null);
            setTripAmountEditOpen(false);
            trackDwebEvent('Dweb Party Payment Trip Amount Changed', {
                party_id: partyIdValue,
                party_name: user && user.partyName ? user.partyName : "",
                party_contact_number: user && user.partyMobile ? user.partyMobile : "",
                party_balance: user && user.partyBalance ? user.partyBalance : "",
                payment_amount: amountValue ? amountValue : "",
                payment_method: paymentMethodValue ? paymentMethodValue : "Cash",
                payment_date: paymentDateValue ? paymentDateValue : new Date(),
                received_by_driver: isReceivedByDriverFlag,
                trip_id: selectedForEdit && selectedForEdit.tripId ? selectedForEdit.tripId : "",
                trip_party_balance: selectedForEdit && selectedForEdit.tripBalance ? selectedForEdit.tripBalance : 0,
                trip_payment_amount: selectedAmount ? selectedAmount : 0,
            });
        }
    }

    const getAmountFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAmountContainer} >
                        <div className={classes.titleV3}>Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setSelectedAmount(e.target.value)
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            className={classes.mtV4}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            }
        ]
    }

    const editAmountValidate = values => {
        const errors = {};
        let allocatedAmount = 0;

        let ignoreTripId = checkedTrips && checkedTrips[tripKey] && checkedTrips[tripKey].tripId ? checkedTrips[tripKey].tripId : "";

        for (var i = 0; i < trips.length; i++) {
            let filteredTrip = checkedTrips.filter((tripData) => {
                return tripData.tripId == (trips[i] ? trips[i] : "") && tripData.tripId != ignoreTripId
            })
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (values && !values.amount) {
            setDialogConfirmDisabled(true);
        } else {
            setDialogConfirmDisabled(false);
        }

        if (values && values.amount && Number(replaceCommas(values.amount)) > (Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))) {
            errors.amount = "Amount cannot be greater than " + numberFormat(Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))
        }

        return errors;
    }

    return (
        <>
            {dialogOpen && <RightSideBar
                sideBarName="add-payment-single-party"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={sideBarTitle =='Choose Opening Balance/Trips'?'Choose Trips':sideBarTitle}
                sideBarType={"paymentDetailSingleParty"}
                handleSubmit={event => submit(event)}
                toggleRightSideBar={handleCancel}
                chooseTripConfirm={event => tripSubmit(event)}
                backClick={handleBackClick}
                confirmText={buttonText}
                onValidate={validate(initialValues)}
                fullyAllocatedFlag={fullyAllocted}
                allocatedTextValue={allocatedText}
                tripsError={tripsError}
            >

                <Grid container justify="space-between" wrap="nowrap" className={classes.gridContainer}>
                    <Grid container direction="column">
                        <Grid item className={classes.titleV1} >
                            Party Name
                        </Grid>
                        <Grid item className={classes.textV1} >
                            {partyName ? partyName : ""}
                        </Grid>
                    </Grid>
                    <Grid container direction="column">
                        <Grid item className={classes.titleV2}>
                            {sideBarTitle == "Add Party Payment" &&
                                <>
                                    Total Balance
                                </>
                            }
                            {sideBarTitle == "Choose Opening Balance/Trips" &&
                                <>
                                    Payment Amount
                                </>
                            }
                        </Grid>
                        <Grid item className={classes.textV2}>
                            {sideBarTitle == "Add Party Payment" &&
                                <>
                                    {numberFormat(user && user.partyBalance ? user.partyBalance : 0)}
                                </>
                            }
                            {sideBarTitle == "Choose Opening Balance/Trips" &&
                                <>
                                    {amountValue ? numberFormat(replaceCommas(amountValue)) : numberFormat(0)}
                                </>
                            }
                        </Grid>
                    </Grid>
                </Grid>

                {sideBarTitle == "Add Party Payment" &&
                    <div className={classes.mtV1} >
                        <Form
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                }

                {sideBarTitle == "Choose Opening Balance/Trips" &&
                    <div>
                        <Form
                            onSubmit={onTripSubmit}
                            initialValues={initialTripValues}
                            validate={tripValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getTripFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                }

            </RightSideBar>
            }

            {/* ******************************** Dialog to edit trip amount (trip attribution amount.) ******************************** */}
            {tripAmountEditOpen &&
                <Dialog fullwidth={true} maxWidth='sm' onClose={handleEditAmountClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="trip-amount-edit-dialog-title" open={tripAmountEditOpen} className={classes.dialogV1} classes={{ paperWidthSm: classes.widthV1 }} >
                    <DialogTitle id="trip-amount-edit-dialog-title" className={classes.dialogTitleV1}>
                        <div className={classes.divAlignTitle} >
                            <div className={classes.divTitle} >
                            {!selectedForEdit.openingBalanceId?'Enter Amount':'Amt linked to Opening Balance'}
                            </div>
                            <div>
                                <IconButton onClick={handleEditAmountClose}>
                                    <CloseIcon className={classes.closeIconV1} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers className={classes.dialogContentV1}>

                        <Grid container direction="column">

                            {!selectedForEdit.openingBalanceId?<Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridTitleDialog}>
                                <Grid item>
                                    Trip Details
                                </Grid>
                                <Grid item>
                                    Balance
                                </Grid>
                            </Grid>:null}

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridContainerDialog}>

                                <Grid container direction="column" wrap="nowrap" classes={{ container: classes.containerWidth }}>
                                    {!selectedForEdit.openingBalanceId && <Grid item className={classes.gridRouteDialog}>
                                    <><span>{selectedForEdit && selectedForEdit.startLocation ? selectedForEdit.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{selectedForEdit && selectedForEdit.destinationLocation ? selectedForEdit.destinationLocation : ""}</span></>
                                    </Grid>}
                                    <Grid item className={classes.gridParamsDialog} >
                                        {selectedForEdit && selectedForEdit.params.length > 0 && selectedForEdit.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != selectedForEdit.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV2} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                    {selectedForEdit.openingBalanceId && <Grid item className={classes.gridRouteDialog}>
                                        <span>Total balance&nbsp;&nbsp;<span style={{color:'#0033cc',fontWeight:600,fontSize:17}}>{selectedForEdit && selectedForEdit.tripBalance ? numberFormat(selectedForEdit.tripBalance) : numberFormat(0)}</span></span>
                                    </Grid>}
                                </Grid>

                                {!selectedForEdit.openingBalanceId?<Grid item className={classes.containerWidth}>
                                    <div className={classes.textBalance}>
                                        {selectedForEdit && selectedForEdit.tripBalance ? numberFormat(selectedForEdit.tripBalance) : numberFormat(0)}
                                    </div>
                                </Grid>:null}

                            </Grid>

                        </Grid>

                        <Form
                            onSubmit={onTripEditSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialTripAmountValues}
                            validate={editAmountValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripEditSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getAmountFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />

                    </DialogContent>
                    <DialogActions className={classes.dialogActionsV1} >
                        <Button variant="contained" className={classes.closeButton} onClick={handleEditAmountClose} >
                            Close
                        </Button>
                        <Button className={classes.saveButton} variant="contained" onClick={onTripEditSubmit} disabled={dialogConfirmDisabled} classes={{ disabled: classes.saveButtonDisabled }} >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetSuggestionsTrips: (data, onSuccess, onError) => {
        dispatch(getSuggestionsTrips(data, onSuccess, onError))
    },
    dispatchAddPartyPayment: (data, onSuccess, onError) => {
        dispatch(addSinglePartyPayment(data, onSuccess, onError))
    },
    dispatchGetAllDrivers: (onSuccess, onFailure) => {
        dispatch(getAllDrivers(null, onSuccess, onFailure))
    },

});

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentSingleParty);